/**
 * Created by tomers on 5/6/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var Page = require("ui.components/page/Page");
    var LEConfig = require("assets/config/le-env-conf");

    var ErrorCodes = require("codeTables/errorCodes.json");
    var AgentGroupsCollection = require("user-management-collections/AgentGroupsCollection");
    var SkillModel = require("models/entities/SkillModel");
    var SkillEditView = require("user-management-views/skills/SkillEditView");
    var SkillsFooterView = require("user-management-views/skills/SkillsFooterView");
    var Settings = require("codeTables/settings.json");
    var TimeUtils = require("reporting-assets/js/TimeUtils");
    var TimeUtilities = require("utils/TimeUtilities");

    var SkillEditController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        SkillEditController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            skillModel: null,
            initialize: function(options) {
                this._initialize(options);
            },

            getView: function() {
                return this.pageView;
            },
            showSkillEdit: function(skillId) {
                this._showSkillEdit(skillId);
            },

            _initialize: function(options) {
                LEUserManagement.logger.info("initializing", "SkillEditController:initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.SKILL_EDIT);
                this._initPageView();
                this._bindEvents();
            },

            _initPageView: function(){
                LEUserManagement.logger.debug("init page view and listen to its close", "SkillEditController:_initPageView");
                this.pageView = new Page({
                    moduleName: LEUserManagement.moduleName,
                    context: LE.context,
                    permutation: Page.PERMUTATION.Standard,
                    contentWidth: Page.CONTENT_WIDTH.Large,
                    header:{
                        knowledgePack: {text: LE.translator.translate("LEFramework.global.captions.learnMore"), eventId: "working-with-skills"}
                    },
                    footer: new SkillsFooterView()
                });
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _bindEvents: function() {
                this.listenTo(this.channel.vent, "skill:change:name", this._onNameChange);
                this.listenTo(this.channel.vent, "skill:change:description", this._onDescriptionChange);
                this.listenTo(this.channel.vent, "skill:change:maxWaitTime", this._onMaxWaitTimeChange);
                this.listenTo(this.channel.vent, "skill:change:lobs", this._onLobsChange);
                this.listenTo(this.channel.vent, "skill:change:canTransfer", this._onCanTransferChange);
                this.listenTo(this.channel.vent, "skill:change:transferSkills", this._onTransferSkillsChange);
                this.listenTo(this.channel.vent, "skill:change:defaultPostChatSurvey", this._onDefaultPostChatSurveyChange);
                this.listenTo(this.channel.vent, "skill:change:defaultOfflineSurvey", this._onDefaultOfflineSurveyChange);
                this.listenTo(this.channel.vent, "skill:change:defaultAgentSurvey", this._onDefaultAgentSurveyChange);
                this.listenTo(this.channel.vent, "skill:change:postChatSurveyCheckbox", this._onPostChatSurveyDisabled);
                this.listenTo(this.channel.vent, "skill:change:offlineSurveyCheckbox", this._onOfflineSurveyDisabled);
                this.listenTo(this.channel.vent, "skill:change:agentSurveyCheckbox", this._onAgentSurveyDisabled);
                this.listenTo(this.channel.vent, "skill:change:wrapUp", this._onWrapUpChange);
                this.listenTo(this.channel.vent, "skill:change:workingHours", this._onWorkingHoursChange);
                this.listenTo(this.channel.vent, "skill:change:specialOccasion", this._onSpecialOccasionChange);
                this.listenTo(this.channel.vent, "skill:sla:type:change", this._onSLATypeChange);
                this.listenTo(this.channel.vent, "skill:transferToAgent:type:change", this._onTransferToAgentTypeChange);
                this.listenTo(this.channel.vent, "skill:change:transferToAgent", this._onTransferToAgentChange);
                this.listenTo(this.channel.vent, "skill:sla:default:change", this._onSlaDefaultChange);
                this.listenTo(this.channel.vent, "skill:sla:urgent:change", this._onSlaUrgentChange);
                this.listenTo(this.channel.vent, "skill:sla:firstTime:change", this._onSlaFirstTimeChange);
                this.listenTo(this.channel.vent, "skill:open:scheduleGallery", this._onScheduleGalleryOpenClick);
                this.listenTo(this.channel.vent, "skill:open:specialOccasionGallery", this._onSpecialOccasionGalleryOpenClick);
                this.listenTo(this.channel.vent, "skill:autoClose:type:change", this._onAutoCloseTypeChange);
                this.listenTo(this.channel.vent, "skill:change:autoClose", this._onAutoCloseChange);

                LEUserManagement.channel.comply(LE.mediaCodes.global.commands.schedule.workingHoursSkill, this._onWorkingHoursChangeFromGallery, this);
                LEUserManagement.channel.comply(LE.mediaCodes.global.commands.specialOccasion.workingHoursSkill, this._onSpecialOccasionChangeFromGallery, this);

                this.listenTo(this.channel.vent, "skill:cancel", this._onCancel);
                this.listenTo(this.channel.vent, "skill:save", this._onSave);
            },

            _isLoadBalanceSection: function() {
                return LE.sessionManager.hasAgentGroupsFeature() && LE.sessionManager.hasMultiChatCenterLoadBalancing();
            },

            //Since this is an internal section of load balancing, we must verify first that the parent section will be displayed too
            _isCascadingLoadBalanceSection: function() {
                return this._isLoadBalanceSection() && LE.sessionManager.hasMultiChatCenterCascadingLoadBalancing();
            },

            _isLobAssignmentSection: function() {
                return LE.sessionManager.hasEntitiesTaggingByLobFeature();
            },

            _showSkillEdit: function(skillId) {
                LEUserManagement.logger.info("show skill edit view", "SkillEditController:_showSkillEdit", skillId);
                if (skillId === CONST.ROUTING.NEW_ITEM_ID) {
                    if (this.skillModel && this.skillModel.isNew()) {
                        this._closeLayoutLoader();
                        this._showView();
                    }
                    else {
                        this._createNewSkill();
                    }
                }
                else {
                    if (this.skillModel && this.skillModel.id === parseInt(skillId, 10)) {
                        this._closeLayoutLoader();
                        this._showView();
                    }
                    else {
                        this._fetchSkill(skillId);
                    }
                }
            },

            _createNewSkill: function() {
                this.skillModel = new SkillModel();
                this._showView();
            },

            _fetchSkill: function(skillId) {
                this.skillModel = new SkillModel({id:skillId});
                this._showLayoutLoader();
                this.skillModel.fetch({
                    success: _.bind(this._onFetchSkillSuccess, this),
                    error:  _.bind(this._onFetchSkillError, this)
                });
            },

            _onFetchSkillError: function(model, response, options) {
                LEUserManagement.logger.debug("fetch skill error, closing loader and returning to list", "SkillEditController:_onFetchSkillError", response);
                this._closeLayoutLoader();
                LEUserManagement.notifier.showError({content:LE.translator.translate("LEUserManagement.skillEdit.errorOnFetching.text"), timeToShow: 6000});
                this._navigateToSkillList();
            },

            _onFetchSkillSuccess: function(model, response, options) {
                LEUserManagement.logger.debug("fetch skill success, closing loader and displaying view", "SkillEditController:_onFetchSkillSuccess", response);
                this._closeLayoutLoader();
                this._showView();
            },

            _showView: function() {
                var agentGroups = this._isLoadBalanceSection() ? LEUserManagement.getDataManager().getAgentGroupsCollection() : null;
                var surveys = LE.sessionManager.hasConfigureDefaultSurveyForSkillChange() ? LEUserManagement.getDataManager().getSurveyCollection() : null;
                LEUserManagement.logger.debug("show the skill edit view in the page", "SkillEditController:_showView");
                var title = (this.skillModel.isNew()) ? LE.translator.translate("LEUserManagement.skillEdit.header.title.new") : LE.translator.translate("LEUserManagement.skillEdit.header.title.edit");
                var wrapUpTimeDefaultValue = null;
                if (LE.sessionManager.hasWrapUpTimeFeature()){
                    var wrapUpTimeObject = LEUserManagement.getDataManager().getSiteSettingsWrapUpTime().get(Settings.SETTING_ID.WRAP_UP_TIME).getValue();
                    if (wrapUpTimeObject.active){
                        wrapUpTimeDefaultValue = wrapUpTimeObject.time;
                    }
                }

                if (LE.sessionManager.hasSLAPerSkillFeature()) {
                    this._handleSlaPerSkillFeature();
                }

                if (LE.sessionManager.hasMessagingTransferToAgentFeature()) {
                    this._handleTransferToAgentFeature();
                }

                if (LE.sessionManager.hasAutoClosePerSkillFeature()) {
                    this._handleAutoCloseFeature();
                }

                var showScheduledWorkingHours = (LEConfig.scheduledWorkingHours && LE.sessionManager.hasAsyncMessagingFeature());
                if (showScheduledWorkingHours) {
                    var workingHoursType = _.isNull(this.skillModel.getWorkingHours()) ? this.skillModel.WORKING_HOURS_TYPES.ACCOUNT : this.skillModel.WORKING_HOURS_TYPES.CUSTOM;
                    this.skillModel.setWorkingHoursType(workingHoursType);

                    var specialOccasionType = _.isNull(this.skillModel.getSpecialOccasion()) ? this.skillModel.WORKING_HOURS_TYPES.ACCOUNT : this.skillModel.WORKING_HOURS_TYPES.CUSTOM;
                    this.skillModel.setSpecialOccasionType(specialOccasionType);
                }

                this.insideView = new SkillEditView({
                    model: this.skillModel,
                    agentGroupsCollection: agentGroups,
                    surveyCollection: surveys,
                    showCascadingLoadBalanceSection: this._isCascadingLoadBalanceSection(),
                    showLobAssignmentSection: this._isLobAssignmentSection(),
                    showScheduledWorkingHours: showScheduledWorkingHours,
                    wrapUpTimeDefaultValue:wrapUpTimeDefaultValue
                });

                this.pageView.setTitle(title);
                this.pageView.setDescription(LE.translator.translate("LEUserManagement.skillEdit.header.description"));
                this.pageView.setInsideView(this.insideView);
            },
            _handleSlaPerSkillFeature: function() {
                var slaPerSkillSiteSettings =  LEUserManagement.getDataManager().getSiteSettingsSLA();

                var defaultResponseTimeUnit = slaPerSkillSiteSettings.get(Settings.SETTING_ID.DEFAULT_SLA_UNITS).getValue();
                var defaultResponseTime = slaPerSkillSiteSettings.get(Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME).getValue();
                var urgentResponseTimeUnit = slaPerSkillSiteSettings.get(Settings.SETTING_ID.URGENT_SLA_UNITS).getValue();
                var urgentResponseTime = slaPerSkillSiteSettings.get(Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME).getValue();
                var firstTimeResponseTimeUnit = slaPerSkillSiteSettings.get(Settings.SETTING_ID.FIRST_TIME_SLA_UNITS).getValue();
                var firstTimeResponseTime = slaPerSkillSiteSettings.get(Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME).getValue();

                var defaultResponseTimeInSeconds = TimeUtils.convertMinutesOrHoursOrDaysToSeconds(defaultResponseTime, defaultResponseTimeUnit);
                var urgentResponseTimeInSeconds = TimeUtils.convertMinutesOrHoursOrDaysToSeconds(urgentResponseTime, urgentResponseTimeUnit);
                var firstTimeResponseTimeInSeconds = TimeUtils.convertMinutesOrHoursOrDaysToSeconds(firstTimeResponseTime, firstTimeResponseTimeUnit);

                this.siteSettingsSlaPerSkills = {
                    defaultResponseTimeInSeconds: defaultResponseTimeInSeconds,
                    urgentResponseTimeInSeconds: urgentResponseTimeInSeconds,
                    firstTimeResponseTimeInSeconds: firstTimeResponseTimeInSeconds
                };

                var slaType = this.skillModel.isCustomSla() ? this.skillModel.SLA_RESPONSE_TIME_TYPES.CUSTOM : this.skillModel.SLA_RESPONSE_TIME_TYPES.ACCOUNT;
                this.skillModel.setSLAResponseTimeType(slaType);
            },
            _onNameChange: function(name) {
                this.skillModel.setName(name);
            },

            _onDescriptionChange: function(description) {
                this.skillModel.setDescription(description);
            },

            _onMaxWaitTimeChange: function(maxWaitTime) {
                this.skillModel.setMaxWaitTime(maxWaitTime);
            },

            _onLobsChange: function(lobIds) {
                this.skillModel.setLobs(lobIds);
            },

            _onCanTransferChange: function(canTransfer) {
                this.skillModel.setCanTransfer(canTransfer);
            },

            _onTransferSkillsChange: function(transferSkillsIds) {
                this.skillModel.setTransferSkills(transferSkillsIds);
            },

            _onDefaultPostChatSurveyChange: function(defaultPostChatSurvey) {
                this.skillModel.setDefaultSurveyPostChat(defaultPostChatSurvey);
            },

            _onDefaultOfflineSurveyChange: function(defaultOfflineSurvey) {
                this.skillModel.setDefaultSurveyOffline(defaultOfflineSurvey);
            },

            _onDefaultAgentSurveyChange: function(defaultAgentSurvey) {
                this.skillModel.setDefaultSurveyAgent(defaultAgentSurvey);
            },

            _onPostChatSurveyDisabled: function(checked) {
                if (!checked) {
                    this._onDefaultPostChatSurveyChange(SkillModel.EMPTY_VALUE);
                }
            },

            _onOfflineSurveyDisabled: function(checked) {
                if (!checked) {
                    this._onDefaultOfflineSurveyChange(SkillModel.EMPTY_VALUE);
                }
            },

            _onAgentSurveyDisabled: function(checked) {
                if (!checked) {
                    this._onDefaultAgentSurveyChange(SkillModel.EMPTY_VALUE);
                }
            },

            _onSLATypeChange: function(selectedKey) {
                var defaultResponseTimeInSeconds;
                var urgentResponseTimeInSeconds;
                var firstTimeResponseTimeInSeconds;

                if (selectedKey === this.skillModel.SLA_RESPONSE_TIME_TYPES.CUSTOM) {
                    defaultResponseTimeInSeconds = this.siteSettingsSlaPerSkills.defaultResponseTimeInSeconds;
                    urgentResponseTimeInSeconds = this.siteSettingsSlaPerSkills.urgentResponseTimeInSeconds;
                    firstTimeResponseTimeInSeconds = this.siteSettingsSlaPerSkills.firstTimeResponseTimeInSeconds;
                }
                var slaOptions = {
                    defaultResponseTimeInSeconds: defaultResponseTimeInSeconds,
                    urgentResponseTimeInSeconds: urgentResponseTimeInSeconds,
                    firstTimeResponseTimeInSeconds: firstTimeResponseTimeInSeconds,
                    slaResponseType: selectedKey
                };

                this.skillModel.updateSLA(slaOptions);
                this.insideView.updateSlaTimeValues(slaOptions);
                this.insideView.toggleCustomConfigurationVisibility();
            },

            _handleTransferToAgentFeature: function () {
                var transferToAgentSiteSettings = LEUserManagement.getDataManager().getSiteSettingsTransferToAgent();
                var transferToAgentInSeconds = transferToAgentSiteSettings && transferToAgentSiteSettings.getValue();

                this.siteSettingsTransferToAgent = transferToAgentInSeconds;

                var transferToAgentType = _.isNull(this.skillModel.getTransferToAgent()) ? this.skillModel.TRANSFER_TO_AGENT_TYPES.ACCOUNT : this.skillModel.TRANSFER_TO_AGENT_TYPES.CUSTOM;
                this.skillModel.setTransferToAgentType(transferToAgentType);
            },

            _onTransferToAgentTypeChange: function (transferToAgentType) {
                var transferToAgentInSeconds;

                if (transferToAgentType === this.skillModel.SLA_RESPONSE_TIME_TYPES.CUSTOM) {
                    transferToAgentInSeconds = this.siteSettingsTransferToAgent;
                }

                this.skillModel.setTransferToAgentType(transferToAgentType);
                this.skillModel.setTransferToAgent(transferToAgentInSeconds);
                this.insideView.updateTransferToAgentTimeValues(transferToAgentInSeconds);
                this.insideView.toggleCustomTransferToAgentConfigurationVisibility();
            },

            _onTransferToAgentChange: function (transferValue) {
                var transferToAgentInSeconds = TimeUtilities.convertToSeconds(transferValue.timeValue, transferValue.timeUnit);
                this.skillModel.setTransferToAgent(transferToAgentInSeconds);
            },

            _handleAutoCloseFeature: function () {
                var autoCloseSiteSettings = LEUserManagement.getDataManager().getSiteSettingsAutoClose();
                var autoCloseInSeconds = autoCloseSiteSettings && autoCloseSiteSettings.getValue();

                this.siteSettingsAutoClose = autoCloseInSeconds;

                var autoCloseType = _.isNull(this.skillModel.getAutoClose()) ? this.skillModel.AUTO_CLOSE_TYPES.ACCOUNT : this.skillModel.AUTO_CLOSE_TYPES.CUSTOM;
                this.skillModel.setAutoCloseType(autoCloseType);
            },

            _onAutoCloseTypeChange: function (autoCloseType) {
                var autoCloseInSeconds;

                if (autoCloseType === this.skillModel.SLA_RESPONSE_TIME_TYPES.CUSTOM) {
                    autoCloseInSeconds = this.siteSettingsAutoClose;
                }

                this.skillModel.setAutoCloseType(autoCloseType);
                this.skillModel.setAutoClose(autoCloseInSeconds);
                this.insideView.updateAutoCloseTimeValues(autoCloseInSeconds);
                this.insideView.toggleCustomAutoCloseConfigurationVisibility();
            },

            _onAutoCloseChange: function (autoCloseValue) {
                var autoCloseInSeconds = TimeUtilities.convertToSeconds(autoCloseValue.timeValue, autoCloseValue.timeUnit);
                this.skillModel.setAutoClose(autoCloseInSeconds);
            },

            _onSlaDefaultChange: function(defaultValues) {
                this.skillModel.setSlaDefaultResponseTime(TimeUtils.convertMinutesOrHoursOrDaysToSeconds(defaultValues.timeValue, defaultValues.timeUnit));
            },

            _onSlaUrgentChange: function(urgentValues) {
                this.skillModel.setSlaUrgentResponseTime(TimeUtils.convertMinutesOrHoursOrDaysToSeconds(urgentValues.timeValue, urgentValues.timeUnit));
            },

            _onSlaFirstTimeChange: function(firstTimeValues) {
                this.skillModel.setSlaFirstTimeResponseTime(TimeUtils.convertMinutesOrHoursOrDaysToSeconds(firstTimeValues.timeValue, firstTimeValues.timeUnit));
            },

            _onWrapUpChange: function(wrapUpTime) {
                var value = _.isEmpty(wrapUpTime) ? null : Math.round(parseFloat(wrapUpTime));
                this.skillModel.setWrapUpTime(value);
            },

            _onWorkingHoursChange: function(options) {
                this.skillModel.setWorkingHours(options.selectedItemId);
                if (_.has(options, "type")) {
                    this.skillModel.setWorkingHoursType(options.type);
                }
            },

            _onWorkingHoursChangeFromGallery: function(options) {
                //validate the trigger is for this specific model
                if ((options.contextEntityId === String(this.skillModel.id)) || (options.contextEntityId === CONST.ROUTING.NEW_ITEM_ID && this.skillModel.isNew())) {
                    this._onWorkingHoursChange(options);
                }
            },

            _onSpecialOccasionChange: function(options) {
                this.skillModel.setSpecialOccasion(options.selectedItemId);
                if (_.has(options, "type")) {
                    this.skillModel.setSpecialOccasionType(options.type);
                }
            },

            _onSpecialOccasionChangeFromGallery: function(options) {
                //validate the trigger is for this specific model
                if ((options.contextEntityId === String(this.skillModel.id)) || (options.contextEntityId === CONST.ROUTING.NEW_ITEM_ID && this.skillModel.isNew())) {
                    this._onSpecialOccasionChange(options);
                }
            },

            _onScheduleGalleryOpenClick: function() {
                var galleryRoute = LE.context.get("navigationCurrent.route") + "/schedules";
                if (this.skillModel.getWorkingHours()) {
                    galleryRoute += "/select/" + this.skillModel.getWorkingHours();
                }

                LE.crossModule("manager", LE.media.actions.command, LE.mediaCodes.manager.commands.openScheduleGallery, galleryRoute);
            },

            _onSpecialOccasionGalleryOpenClick: function() {
                var galleryRoute = LE.context.get("navigationCurrent.route") + "/specialOccasions";
                if (this.skillModel.getSpecialOccasion()) {
                    galleryRoute += "/select/" + this.skillModel.getSpecialOccasion();
                }

                LE.crossModule("manager", LE.media.actions.command, LE.mediaCodes.manager.commands.openSpecialOccasionGallery, galleryRoute);
            },

            _onCancel: function() {
                LEUserManagement.logger.info("cancel the skill edit", "SkillEditController:_onCancel");

                this._navigateToSkillList();
            },

            _onSave: function() {
                LEUserManagement.logger.info("save the skill", "SkillEditController:_onSave", this.skillModel);
                this._beforeSave();
                this.skillModel.save(null, {
                    ignoreError: true,
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSaveSuccess: function(model, resp, options) {
                LEUserManagement.logger.info("skill saved successfully", "SkillEditController:_onSaveSuccess", model);

                this._afterSave();
                LEUserManagement.getDataManager().updateCollection(model);
                this._navigateToSkillList();
            },

            _onSaveError: function(model, resp, options) {
                LEUserManagement.logger.info("skill could not be saved", "SkillEditController:_onSaveError", model);
                this._afterSave();
                var errorMessage = LE.translator.translate("LEFramework.something.went.wrong");
                errorMessage = options.errorMessage ? options.errorMessage : errorMessage;
                if (resp && _.has(resp, "responseError") ) {
                    if (resp.responseError.internalCode === ErrorCodes.dependencyConflict){
                        errorMessage = LE.translator.translate("LEFramework.entities.skill.errors.dependency.conflict");
                    } else if (resp.responseError.internalCode === ErrorCodes.concurrentModificationConflict) {
                        errorMessage = LE.translator.translate("LEUserManagement.skillEdit.errors.outdated.revision");
                    } else if (resp.responseError.internalCode === ErrorCodes.noDataFound) {
                        errorMessage = LE.translator.translate("LEUserManagement.skillEdit.errors.skill.was.deleted");
                        this._onCancel();
                    }
                }

                if (resp && resp.responseError && resp.responseError.internalCode === ErrorCodes.concurrentModificationConflict) {
                    errorMessage = LE.translator.translate("LEUserManagement.skillEdit.errors.outdated.revision");
                }
                var messageToShow = (!_.isEmpty(options.errorObject)) ? LEUserManagement.getGeneralErrorMsg(options.errorObject) : errorMessage;
                if (!_.isEmpty(messageToShow)) {
                    LEUserManagement.notifier.showError(messageToShow);
                }
                if((!_.isEmpty(options.errorObject))) {
                    this.channel.trigger("skill:save:error", options.errorObject);
                }
            },

            _onSaveInvalid: function(model, errorObject) {
                LEUserManagement.logger.info("skill could not be saved", "SkillEditController:_onSaveInvalid", model);

                this._afterSave();

                var translatedErrorObj = {};
                _.each(errorObject, function (value, key, obj) {
                    translatedErrorObj[key] = LE.translator.translate(value);
                });

                LEUserManagement.notifier.showError(LEUserManagement.getGeneralErrorMsg(translatedErrorObj));
                this.channel.trigger("skill:save:error", translatedErrorObj);
            },

            _beforeSave: function() {
                this._showLoader();
                this.listenTo(this.skillModel, "invalid", this._onSaveInvalid);
            },

            _afterSave: function() {
                this.stopListening(this.skillModel, "invalid");
                this._closeLoader();
            },

            _showLoader: function() {
                this.pageView.showLoader();
            },

            _closeLoader: function() {
                this.pageView.closeLoader();
            },

            _showLayoutLoader: function() {
                LEUserManagement.showLoader();
            },

            _closeLayoutLoader: function() {
                LEUserManagement.closeLoader();
            },

            _navigateToSkillList: function() {
                LEUserManagement.logger.info("navigate to skill list", "SkillEditController:_navigateToSkillList");
                this.skillModel = null;
                LEUserManagement.router.navigate("skills");
            },

            _onPageClose: function() {
                LEUserManagement.logger.debug("Page component in skill edit is closed. re-init it.", "SkillEditController:onPageClose");
                this.insideView = null;
                this.stopListening(this.pageView);
                this._initPageView();
            }

        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return  SkillEditController;
});
